import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 36, className = "", once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1", ...rest }) {
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag className={className} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}{i < lines.length - 1 ? " " : ""}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

export function Stagger({ children, className = "", gap = 0.08, delay = 0, ...rest }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
      variants={{ visible: { transition: { staggerChildren: gap, delayChildren: delay } } }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "" }) {
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y: 28 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
      }}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ index, title, dark = false, className = "" }) {
  return (
    <Reveal className={`flex items-center gap-4 ${className}`}>
      <span className={`font-display text-xs font-semibold tracking-[0.3em] ${dark ? "text-clay" : "text-forest"}`}>
        {index}
      </span>
      <span className={`h-px w-12 ${dark ? "bg-offwhite/25" : "bg-charcoal/25"}`} />
      <span
        className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-offwhite/60" : "text-charcoal/60"}`}
      >
        {title}
      </span>
    </Reveal>
  );
}
